var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getPublicSettings, getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Alert, Button, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { missionPositionFormConfig } from '../features/mission-admin-pages/components/MissionPositionAdminPage';
import { useMissionPositionStorage, useMissionsTranslation } from '../hooks';
export const renderCreatePositionDialog = (props) => {
    return React.createElement(CreatePositionDialog, Object.assign({}, props));
};
export const CreatePositionDialog = ({ handler, isEdit }) => {
    const userState = useSelector((state) => { var _a, _b; return (_b = (_a = state.platform.user) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.state; });
    const settings = useSelector(userState ? getSettings : getPublicSettings);
    const { t } = useMissionsTranslation();
    const missionPositionStorage = useMissionPositionStorage();
    const handleSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const response = yield missionPositionStorage.post({
                action: 'create',
                data: data,
            });
            const positions = isEdit ? handler.up().down('additionalPositions') : handler.up().down('positions');
            const positionData = positions === null || positions === void 0 ? void 0 : positions.getData();
            if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.status) === 'active') {
                positions === null || positions === void 0 ? void 0 : positions.setData([
                    ...positionData,
                    {
                        positionId: response.id,
                    },
                ]);
            }
            showAlertSnackbar({
                message: t('shifts.createPositionSuccess'),
                type: 'success',
                autoHideDuration: 2000,
                horizontalPosition: 'right',
            });
        }
        catch (e) {
            handleErrorDialog(e);
        }
    });
    const handleOpenCreatePositionDialog = () => {
        showFormDialog({
            title: t('shifts.createPositionTitle'),
            submitLabel: t('common.create'),
            maxWidth: 'sm',
            config: missionPositionFormConfig(t, settings, userState, false),
            onSubmit: handleSubmit,
        });
    };
    return (React.createElement(Alert, { severity: 'info', action: React.createElement(Button, { color: 'inherit', size: 'small', onClick: handleOpenCreatePositionDialog, "data-test": 'add-new-position-button' }, t('shifts.createPositionButton')) },
        React.createElement(Typography, { variant: 'subtitle2' }, t('shifts.createPositionInfo'))));
};
